// import RulePack from './RulePack';

export default {
  priority: 40,
  path: "packet",
  permissions: ["cascascaSaascaslarascascay/ascascas"],  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./SalaryItems")
  ),
  name: app.translate("آیتم های حقوق و دستمزد"),
  icon: "content-paste",
  drawer: true,
};
